import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Loader2 } from "lucide-react";

export function ChatLoadingIndicator() {
  return (
    <div className="flex justify-start">
      <div className="flex gap-3">
        <Avatar className="h-8 w-8">
          <AvatarFallback className="bg-purple-500 text-white">
            AI
          </AvatarFallback>
        </Avatar>
        <div className="bg-gray-100 rounded-lg p-4">
          <div className="flex items-center gap-2">
            <Loader2 className="h-4 w-4 animate-spin text-gray-500" />
            <span className="text-xs text-gray-500">Aria is searching the knowledge graph...</span>
          </div>
        </div>
      </div>
    </div>
  );
}
